import { render } from "./BuildingsTable.vue?vue&type=template&id=fdb61efc"
import script from "./BuildingsTable.vue?vue&type=script&lang=js"
export * from "./BuildingsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__